export default __webpack_public_path__ + "static/assets/a9f15670265513bb07a548077817216b.svg";